import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { ChecklistCategoriesVM, ChecklistQuestionsVM, UpdatedCheckList } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { ConfigSetupChecklistAddNewCategoryDialogComponent } from './config-setup-checklist-add-new-category-dialog/config-setup-checklist-add-new-category-dialog.component';
import { ConfigSetupChecklistAddNewQuestionDialogComponent } from './config-setup-checklist-add-new-question-dialog/config-setup-checklist-add-new-question-dialog.component';
import { ConfigSetupChecklistEditCategoryDialoglogComponent } from './config-setup-checklist-edit-category-dialoglog/config-setup-checklist-edit-category-dialoglog.component';
import { ConfigSetupChecklistEditQuestionDialogComponent } from './config-setup-checklist-edit-question-dialog/config-setup-checklist-edit-question-dialog.component';

@Component({
  selector: 'app-config-setup-checklist',
  templateUrl: './config-setup-checklist.component.html',
  styleUrls: ['./config-setup-checklist.component.css']
})
export class ConfigSetupChecklistComponent implements OnInit {
 
  
  checklist:ChecklistCategoriesVM[]=[];
  questionlist:ChecklistQuestionsVM[]=[]
  loading:boolean=false;

  UpdatedList:UpdatedCheckList[]=[]

  constructor(
    public dialog: MatDialog,
    private _safetyConfigService:SafetyConfigService,
   
    //private _mainetec:MainetecService,

  ) { }

  ngOnInit() {
    this.getchecklist();
    
   

  }
  //ConfigSetupChecklistAddNewCategoryDialog
  AddNewCategoryDialog(){
    const dialogRef = this.dialog.open(ConfigSetupChecklistAddNewCategoryDialogComponent, { 
      disableClose: true,
      data:{
  
      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
       
      this.getchecklist();
     
      console.log('The dialog was closed');
     }
   });
  }
  //update category
  updateCategoryDialog(CatInf:ChecklistCategoriesVM){
    const dialogRef = this.dialog.open(ConfigSetupChecklistEditCategoryDialoglogComponent, { 
      disableClose: true,
      data:{
        catId:CatInf.ID
      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
       
      this.getchecklist();
  
      console.log('The dialog was closed');
     }
   });
  }
  
  //update Question
  updateQuestionDialog(CatInf:ChecklistQuestionsVM){
    const dialogRef = this.dialog.open(ConfigSetupChecklistEditQuestionDialogComponent, { 
      disableClose: true,
      data:{
        catId:CatInf.ID,
        CategoryID:CatInf.QuestionCategoryID,
        active:CatInf.Active
        
      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
       
      this.getchecklist();
     
      console.log('The dialog was closed');
     }
   });
  }
  
  
  
  ChangeActive(qus){
    let params = new ChecklistQuestionsVM ();
  
      params.ID = qus.ID;
      params.QuestionName = qus.QuestionName;
      params.QuestionCategoryID = qus.QuestionCategoryID
      params.Active=!qus.Active;
      params.QuestionsDescription=qus.QuestionsDescription;
      
      
  
      //create new category
      this._safetyConfigService.updateQuestion(params).subscribe((res: any) => {
       
        if (res.m_Item1) {
      
          this.getchecklist();
        }
        // this.dialogRef.close();
  
      })
 
      this.getchecklist();
  }
  
  AddnewQuestionDialog(CatInf:ChecklistCategoriesVM){
    const dialogRef = this.dialog.open(ConfigSetupChecklistAddNewQuestionDialogComponent, { 
      disableClose: true,
      data:{
  catId:CatInf.ID
      }
  
      });
      
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
       
      this.getchecklist();
 
      console.log('The dialog was closed');
     }
   });
  
  }
  getchecklist()
  {
    this.loading = true
   this._safetyConfigService.GetAllCategoriesList().subscribe(res => {
     this.checklist=res;
     //this.questionlist=res[0].ChecklistQuestionsVM
     console.log("result data",res);
     this.getquestionlist();
   })
  }

  getquestionlist()
  {
   this._safetyConfigService.GetAllQuestionsList().subscribe(res => {
     this.questionlist=res;
     this.UpdatedList=[]
    //UpdatedList
    this.checklist.map(cat=>{

      let qs = this.questionlist.filter(qus=>qus.QuestionCategoryID && qus.QuestionCategoryID==cat.ID)
      let up=new UpdatedCheckList();
      up.Category = cat;
      up.Questions = qs;

      this.UpdatedList.push(up)
    })
    

     this.loading = false
     console.log("this.UpdatedList",this.UpdatedList);
   })
  }
  
  
    
  }
  